const messages = {
  title: "Shop",
  description: "Welcome to the rewards shop. Here you can redeem your Bridgestone Plus Points <br/> for premiums from the various categories. The product range <br/> is regularly updated. Enjoy browsing.",
  sort: {
    asc: "Sort by: Lowest Price",
    desc: "Sort by: Highest Price",
  },
  productSearchBox: {
    from: "points from",
    to: "points to",
  },
  noProducts: "The search criteria returned no hits",
  quantity: "Quantity",
  search: "Search",
  perPage: "Items per page",
  timeUnavailable: "Currently not available at the time",
  product: "Product",
  cart: {
    pointsPerUnit: "Points/Unit",
    pointsSum: "Points",
  },
  action: "Action",
  pointsTotal: "Total",
  cartRemainPoints: "Points remaining",
  shoppingCart: "Shopping cart",
  emptyCart: "Shopping cart is empty.",
  attributes: "Attributes",
  selectAddressP: "Please select your delivery address",
  orderDelivery: "Shipping address",
  selectedProducts: "Selected products",
  orderSummary: "Order overview",
  contactPerson: "Contact person",
  selectedAddress: "Selected address",
  order: {
    success: "Thank you! Your order was successful. You will receive an order confirmation in your inbox in just a few minutes.",
    description: "Here you will find an overview of your reward shop orders.",
    info: "Here you will find an overview of your reward shop orders.",
    date: "Order date",
    number: "Order no.",
    status: {
      created: "Created",
      confirm_order: "Confirm order",
      ready_for_shipment: "Ready for shipment",
      rejected: "Rejected",
      processed: "Processed",
      shipped: "Shipped",
      returned: "Returned",
      finished: "Finished",
    },
    anyOrder: "No orders",
    products: "Products",
    quantity_short: "pcs",
    itemRemoved: "cannot be delivered",
  },
  orders: "Orders",
  notEnoughPoints: "Not enough points available.",
  statusText: "Status",
  outOfStock: "Currently not on stock",
  productUnavailable: "This product is no longer available.",
  deletedProductsTitle: "Products no longer available",
  deletedProductsMessage: "The following product(s) are no longer available. Remove them from your cart to continue.",
  removeSelected: "Remove selected",
  clearCart: "Clear cart",
  removeSelectedConfirm: "Remove the selected products from your cart?",
  clearCartConfirm: "Remove all products from your cart?",
  incompleteAddress: {
    firstName: "Please add a first name to the delivery address",
    lastName: "Please add a last name to the delivery address",
    company: "Please add a company name to the delivery address",
    street: "Please add a street and house number to the delivery address",
    postalCode: "Please add a postcode to the delivery address",
    city: "Please add a city to the delivery address",
    country: "Please add a country to the delivery address",
    phone: "Please add a phone number to the delivery address",
  },
  placeOrder: "Binding order",
  toOrderDelivery: "Continue to the delivery address",
  toOrderSummary: "To the order overview",
  productImg: "Product image",
  selectAddressBtn: "choose address",
  perPgae: "Items per page",
  categories: {
    advertising: {
      title: "Advertising Materials",
      desc: "Participate directly here on the platform and secure <br/> 40 extra points for the rewards club.",
    },
    rewards: {
      title: "Exclusive rewards",
      desc: "Discover the bonus offer in our training center or at your location.",
    },
    tools: {
      title: "Workshop tools",
      desc: "Use your points for third-party <br/> training and reduce your costs.",
    },
    trainings: {
      title: "Training and education",
      desc: "Discover the bonus offer in our training center or at your location.",
    },
    salesroom: {
      title: "Salesroom",
      desc: "Stage the sales room and offer your customers a pleasant stay.",
    },
    hunter: {
      title: "Hunter",
      desc: "Exchange points for attractive workshop equipment from Hunter.",
    },
  },
  bestSold: "Best-selling",
  seasonal: "Seasonal",
  affordable: "Almost there",
  forPoints: "for {points} points",
  reachedPoints: "Required points reached",
  remainingPoints: "{points} Points remaining",
  favoriteProducts: {
    description: "Here you will find the products you have saved.",
  },
  categoryPageDescriptionFallback: "Workshop materials or other quality products with the Bridgestone logo for your business",
  variant: "Selectable variants",
};
export default {
  messages,
};
